import { supabase } from "@/integrations/supabase/client";
import { MenuItemWithCategory, MenuItem } from "@/types/menu";

/**
 * Fetch a menu item by ID, including its categories
 */
export const fetchMenuItemById = async (
  id: string
): Promise<MenuItem | null> => {
  console.log("fetching menu item by id........", id);
  try {
    // Fetch the menu item data
    const { data: menuItem, error } = await supabase
      .from("menu_items")
      .select("*")
      .eq("id", id)
      .single();

    if (error) {
      console.error("Error fetching menu item:", error);
      return null;
    }

    if (!menuItem) {
      return null;
    }

    // Fetch categories for this menu item
    const { data: categoriesData, error: categoriesError } = await supabase
      .from("menu_items_categories")
      .select("category_id")
      .eq("menu_item_id", id);

    if (categoriesError) {
      console.error("Error fetching menu item categories:", categoriesError);
    }

    const categoryIds = categoriesData?.map((c) => c.category_id) || [];

    // If categoryIds is not empty, fetch the category details
    let categories = [];

    if (categoryIds.length > 0) {
      const { data: categoryDetails, error: categoryDetailsError } =
        await supabase
          .from("menu_categories")
          .select("*")
          .in("id", categoryIds);

      if (categoryDetailsError) {
        console.error("Error fetching category details:", categoryDetailsError);
      } else {
        categories = categoryDetails || [];
      }
    }

    // Fetch tags for this menu item
    const { data: tagsData, error: tagsError } = await supabase
      .from("menu_items_tags")
      .select("tag_id")
      .eq("menu_item_id", id);

    if (tagsError) {
      console.error("Error fetching menu item tags:", tagsError);
    }

    const tagIds = tagsData?.map((t) => t.tag_id) || [];
    let tags: string[] = [];

    if (tagIds.length > 0) {
      const { data: tagDetails, error: tagDetailsError } = await supabase
        .from("menu_tags")
        .select("id, name")
        .in("id", tagIds);

      if (tagDetailsError) {
        console.error("Error fetching tag details:", tagDetailsError);
      } else {
        tags = tagDetails?.map((tag) => tag.name) || [];
      }
    }

    return {
      ...menuItem,
      categoryIds: categoryIds,
      tags: tags,
    };
  } catch (error) {
    console.error("Error in fetchMenuItemById:", error);
    return null;
  }
};
